/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ selected: NonNullable<unknown>, total: NonNullable<unknown> }} Coinvestments_Senddrafts_Selectedcount3Inputs */

const en_coinvestments_senddrafts_selectedcount3 = /** @type {(inputs: Coinvestments_Senddrafts_Selectedcount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.selected} of ${i?.total} selected`)
};

/**
* | output |
* | --- |
* | "{selected} of {total} selected" |
*
* @param {Coinvestments_Senddrafts_Selectedcount3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_selectedcount3 = /** @type {((inputs: Coinvestments_Senddrafts_Selectedcount3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Selectedcount3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_selectedcount3(inputs)
});
export { coinvestments_senddrafts_selectedcount3 as "coInvestments_sendDrafts_selectedCount" }